module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.css,
    attrs: {
      "id": "upload-image"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "image",
      "id": "image"
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), (_vm.state == null) ? _c('i', {
    staticClass: "fa fa-pencil"
  }) : _vm._e(), _vm._v(" "), (_vm.state == 0) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.state == 1) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.state == -1) ? _c('i', {
    staticClass: "fa fa-close"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e83219f","hasScoped":false}!./src/components/upload-image/template.html
// module id = 408
// module chunks = 1